const PlaceholderPage = ({ title = "Coming Soon" }) => {
  return (
    <>
      <h2>{title}</h2>
      <p>This section is under development.</p>
    </>
  );
};

export default PlaceholderPage;
